export enum DATA_TEST_IDS {
  CONTAINER = 'obligation-toolbar',
  YES_BUTTON = 'yes-button',
  NO_BUTTON = 'no-button',
  HIDE_BUTTON = 'hide-button'
}
